import { LimitedCache } from '../../utils/LimitedCache';
import { parseItemsListResponse } from './parsers/items';
import { toError } from './parsers/error';
import { BasedOn, Pricing } from './constants';
import { get } from '../../utils/utils';
export function initItems(settings, http) {
  const listResultsCache = new LimitedCache(settings.itemsCacheCapacity);

  /**
   * Gets list of items
   * @param folderId
   * @param options
   * @returns {Promise}
   * @fulfill {Items}
   * @reject {Error}
   */
  function list(options) {
    options = options || {};
    const paging = get(options, 'paging', {});
    const params = {
      basedOn: get(options, ['basedOn'], BasedOn.PreferredTopics),
      pageSize: paging.size || settings.itemsLimit,
      language: get(options, ['language'], 'en'),
      siteToken: settings.siteMediaToken,
      pricing: Pricing.All,
      wixMediaRoots: 'all',
      shutterstockMediaTypes: 'all',
      unsplashMediaTypes: 'images'
    };
    if (paging.cursor) {
      params.cursor = paging.cursor;
    }
    const cacheId = `${options.cacheId}${paging.cursor ? `:${paging.cursor}` : ''}`;
    if (options.wixMediaRoots && options.wixMediaRoots.length) {
      params.wixMediaRoots = options.wixMediaRoots.join(',');
    } else if (options.wixMediaRoots === null) {
      params.wixMediaRoots = undefined;
    }
    if (options.shutterstockMediaTypes && options.shutterstockMediaTypes.length) {
      params.shutterstockMediaTypes = options.shutterstockMediaTypes.join(',');
    } else if (options.shutterstockMediaTypes === null) {
      params.shutterstockMediaTypes = undefined;
    }
    if (options.unsplashMediaTypes && options.unsplashMediaTypes.length) {
      params.unsplashMediaTypes = options.unsplashMediaTypes.join(',');
    } else if (options.unsplashMediaTypes === null) {
      params.unsplashMediaTypes = undefined;
    }
    if (options.pricing) {
      params.pricing = options.pricing;
    }
    if (listResultsCache.has(cacheId)) {
      return Promise.resolve(listResultsCache.get(cacheId));
    }
    return http.get(`${settings.apiUrl}/_api/media-explorer-server/v1/recommend`, params, {
      withCredentials: true,
      headers: {
        Accept: 'application/json'
      }
    }).then(response => parseItemsListResponse(response, {
      publicMedia: settings.publicMedia
    }, {
      publicMedia: options.thumbnails
    })).then(response => {
      listResultsCache.set(cacheId, response);
      return response;
    }).catch(toError);
  }
  return {
    list
  };
}